import { required, integer } from '@vuelidate/validators'

export const CreateDirectionValidation = {
    fromCityId: { required, integer },
    whereCityId: { required, integer },
    isActive: { integer },
    price: { required, integer },
    deliveryTime: { required, integer },
}
